/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface State {
  activeGoal?: string;
  activeTopic?: string;
  activeLesson?: string;
  activeLearnerType?: string;
}

const initialState: State = {};

/** Actions */

export const stateSlice = createSlice({
  name: "state",
  initialState: initialState,
  reducers: {
    setActiveGoal: (state, action: PayloadAction<string | undefined>) => {
      state.activeGoal = action.payload;
    },
    setActiveTopic: (state, action: PayloadAction<string | undefined>) => {
      state.activeTopic = action.payload;
    },
    setActiveLesson: (state, action: PayloadAction<string | undefined>) => {
      state.activeLesson = action.payload;
    },
    setActiveLearnerType: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.activeLearnerType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder;
  },
});

export const {
  setActiveGoal,
  setActiveTopic,
  setActiveLesson,
  setActiveLearnerType,
} = stateSlice.actions;

export default stateSlice.reducer;
